import colors from './colors/color';
import { getAlphaColor } from './colors/color.utils';

const lightShadowColors = {
  1: getAlphaColor(colors.ND100, 0.04),
  2: getAlphaColor(colors.ND100, 0.08),
  3: getAlphaColor(colors.ND100, 0.12),
  4: getAlphaColor(colors.ND100, 0.14),
  5: getAlphaColor(colors.ND100, 0.24),
};

const shadowOffset = {
  1: `0px 2px 8px 0px`,
  2: `0px 4px 12px 0px`,
  3: `0px 6px 14px 0px`,
  4: `0px 8px 14px 0px`,
  5: `0px 10px 16px 0px`,
};

const lightShadow = {
  1: `${shadowOffset[1]} ${lightShadowColors[1]}`,
  2: `${shadowOffset[2]} ${lightShadowColors[2]}`,
  3: `${shadowOffset[3]} ${lightShadowColors[3]}`,
  4: `${shadowOffset[4]} ${lightShadowColors[4]}`,
  5: `${shadowOffset[5]} ${lightShadowColors[5]}`,
};

export { lightShadow };
export type ShadowTypes = typeof lightShadow;
